import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_ScrollPanel, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.ScrollPanelTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.ScrollPanelTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.ScrollPanelTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.ScrollPanelTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.ScrollPanelTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.ScrollPanelTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.ScrollPanelTypeConst.PLACEHOLDER),
        step: _ctx.getPropertyNumberValue(_ctx.ScrollPanelTypeConst.STEP),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
        onClick: _ctx.clicktest
      }, null, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "step", "modelValue", "onClick"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.ScrollPanelTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}